interface UserMessageProps {
  content: string;
}

export function UserMessage({ content }: UserMessageProps) {
  return (
    <div className="ml-auto max-w-[95%]">
      <div className="rounded-lg bg-secondary px-4 py-3 text-sm text-foreground whitespace-pre-wrap">{content}</div>
    </div>
  );
}
